<template>
  <!--
    Propiedades de una característica de tipo tabla en el editor de formatos.

    Antes iban en el mismo popover que el resto de tipos, y no cabían: la descripción de la
    tabla para la generación de reglas es un texto largo (qué es cada fila, qué columnas son
    obligatorias, qué característica cuenta las filas, con qué otra tabla va alineada) y en un
    popover se escribía por una rendija de tres líneas. Aquí es un modal con áreas de texto
    grandes. Los cambios se escriben directamente en la característica, igual que hacía el
    popover: no hay "guardar", se guarda con el formato.
  -->
  <f7-popup
    class="popup-propiedades-tabla"
    :opened="true"
    @popup:closed="$emit('close')"
  >
    <f7-page>
      <f7-navbar>
        <f7-nav-title>Propiedades de la tabla</f7-nav-title>
        <f7-nav-right>
          <f7-link popup-close icon-f7="xmark"></f7-link>
        </f7-nav-right>
      </f7-navbar>
      <f7-list no-hairlines-md>
        <f7-list-input
          label="Nombre único"
          type="text"
          :readonly="readonly"
          placeholder="Nombre de la característica"
          class="red-placeholder"
          :value="caracteristica.nombre"
          @input="caracteristica.nombre = $event.target.value"
        ></f7-list-input>
        <f7-list-input
          label="Descripción"
          type="textarea"
          resizable
          class="descripcion"
          :readonly="readonly"
          placeholder="Descripción"
          :value="caracteristica.descripcion"
          @input="caracteristica.descripcion = $event.target.value"
        ></f7-list-input>
        <f7-list-input
          label="Descripción de la tabla (para la generación de reglas de auditoría)"
          type="textarea"
          resizable
          class="descripcion-tabla"
          :readonly="readonly"
          placeholder="Qué es cada fila (una bomba, un generador, una muestra), qué columnas son obligatorias, qué característica dice cuántas filas debe haber, con qué otra tabla va alineada fila a fila, si es una tabla de constantes..."
          :value="caracteristica.descripcionTabla"
          @input="caracteristica.descripcionTabla = $event.target.value"
        ></f7-list-input>
        <f7-list-item
          checkbox
          title="Editar desde intranet"
          :disabled="readonly"
          :checked="caracteristica.editarEnIntranet != undefined ? caracteristica.editarEnIntranet : true"
          @change="caracteristica.editarEnIntranet = $event.target.checked"
        ></f7-list-item>
        <f7-list-item
          checkbox
          title="Pasar a plantilla"
          :disabled="readonly"
          :checked="!caracteristica.noPasarAPlantilla"
          @change="caracteristica.noPasarAPlantilla = !$event.target.checked"
        ></f7-list-item>
      </f7-list>
    </f7-page>
  </f7-popup>
</template>
<style>
.popup-propiedades-tabla .descripcion textarea {
  min-height: 90px;
}
.popup-propiedades-tabla .descripcion-tabla textarea {
  min-height: 220px;
}
.popup-propiedades-tabla .item-label {
  white-space: normal;
}
</style>
<script>
export default {
  name: "propiedades-tabla-popup",
  props: {
    caracteristica: { type: Object, required: true },
    readonly: { type: Boolean, default: false },
  },
};
</script>
